import { registerPlugin } from '@capacitor/core';

export interface MuvikaIosVolumeControlPlugin {
  setVolume(options: { volume: number }): Promise<void>;
  getVolume(): Promise<{ volume: number }>;
}

const MuvikaIosVolumeControl = registerPlugin<MuvikaIosVolumeControlPlugin>('MuvikaIosVolumeControl');

export default MuvikaIosVolumeControl;